/** @format */
import * as yup from 'yup';

import {MAX_BUG_DESCRIPTION, MAX_COMMENT} from './constants';

import {FormValues, HypothesisAnswer} from './types';

export const validationSchema: yup.ObjectSchema<FormValues> = yup.object({
  rating: yup.number().nullable().required(),
  hypothesis: yup.mixed<HypothesisAnswer>().nullable().required(),
  dislikes: yup.array().required(),
  bugDescription: yup
    .string()
    .trim()
    .max(MAX_BUG_DESCRIPTION)
    .when('dislikes', {
      is: (dislikes: string[]) => dislikes.includes('bug'),
      then: schema => schema.required(),
      otherwise: schema => schema.notRequired(),
    })
    .defined(),
  screenshots: yup.array().of(yup.string().defined()).defined(),
  comment: yup.string().trim().max(MAX_COMMENT).defined(),
});
